import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import CreateJobForm from './form'

const MapTableDialog = React.forwardRef(function MapTableDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (source) => setDialogState({ open: true, processing: false, source })
  }), [setDialogState])

  return (
    <SydModal
      title='Map Table'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<CreateJobForm source={dialogState.source} onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </SydModal>
  )
})

MapTableDialog.propTypes = {
  onComplete: PropTypes.func
}

MapTableDialog.defaultProps = {
  onComplete: () => {}
}

export default MapTableDialog
